import { render, staticRenderFns } from "./Qrpage.vue?vue&type=template&id=098e419e&"
import script from "./Qrpage.vue?vue&type=script&lang=ts&"
export * from "./Qrpage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports